import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ATTENDANCES_ATTENDANCE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/attendances',
        iconClass: 'fas fa-clipboard',
        name: '::Menu:Attendances',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.Attendances',
      },
    ]);
  };
}
